import { BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS } from 'stash/store/bootstrapActions';

const funding_source_by_type = (state = {}, action) => {
	switch (action.type) {
		case BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS:
			return action.response.funding_sources.reduce((acc, funding_source) => {
				return {
					...acc,
					[funding_source.provider_type]: funding_source,
				};
			}, {});
		default:
			return state;
	}
};

export default funding_source_by_type;
